import { InvitationQuotaTypeEnum } from '@/gql/myomr'
export { default as InvitationQuotaCsvMappingForm } from './InvitationQuotaCsvMappingForm.vue'
export { default as InvitationQuotaCsvUpload } from './InvitationQuotaCsvUpload.vue'
export const supportedKinds = [InvitationQuotaTypeEnum.CrewQuota, InvitationQuotaTypeEnum.PressQuota]
